import ExportOutlined from '@ant-design/icons/ExportOutlined';
import { useTranslation } from 'react-i18next';
import { AppConfig } from '@/config';
import styles from './footer.module.css';

const LINKS = ['company', 'terms', 'privacy'] as const;

/** Company, terms and privacy links (from configuration) and the copyright. */
const ShellFooter = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <footer className={`${styles.footer} ${className ?? ''}`}>
      <ul className={styles.links}>
        {LINKS.map(key => (
          <li key={key}>
            <a
              href={AppConfig.links[key]}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
            >
              {t(`v2.signIn.links.${key}`)}
              <ExportOutlined aria-hidden className={styles.icon} />
              <span className="sr-only">
                {t('v2.common.paren', { text: t('v2.shell.opensNewTab') })}
              </span>
            </a>
          </li>
        ))}
      </ul>
      <span className={styles.copyright}>{t('v2.signIn.footer')}</span>
    </footer>
  );
};

export default ShellFooter;
